<template>
  <div>
    <v-tabs
      align-with-title
      v-model="tab"
    >
      <v-tabs-slider></v-tabs-slider>
      <v-tab
        v-for="(item, index) in browserList"
        :key="index"
        style="text-transform: none"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="(item, index) in browserList"
        :key="index"
      >
        <v-carousel v-model="model" style="height: 335px;" hide-delimiters>
          <v-carousel-item
            v-for="(value, i) in item.src"
            :key="i"
          >
            <v-img :src="value" contain></v-img>
          </v-carousel-item>
        </v-carousel>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tab: null,
      browserList: [
        {
          name: 'Chrome',
          src: [
            require("@/assets/bookmark/help_chrome1,2.png"),
            require("@/assets/bookmark/help_chrome3,4.png"),
            require("@/assets/bookmark/help_chrome5.png"),
            require("@/assets/bookmark/help_chrome6.png"),
            require("@/assets/bookmark/help_chrome7.png")
          ]
        },
        {
          name: 'Safari',
          src: [
            require("@/assets/bookmark/help_safari1,2.png"),
            require("@/assets/bookmark/help_safari3,4.png"),
            require("@/assets/bookmark/help_safari5.png")
          ]
        },
        {
          name: 'はてなブックマーク',
          src: [
            require("@/assets/bookmark/help_hatena1,2.png"),
            require("@/assets/bookmark/help_hatena3.png"),
            require("@/assets/bookmark/help_hatena4.png")
          ]
        },
        {
          name: 'Pocket',
          src: [
            require("@/assets/bookmark/help_pocket.png"),
          ]
        },
      ],
      loading: false,
      modalState: 0,
      model: 0,
    };
  },
  name: 'BookmarkHelpModal',
  methods: {
    changeModalState(changedNumber) {
      this.modalState = changedNumber;
    }
  },
}
</script>